import styled, { css } from 'styled-components';

import { Spacer } from '@ontruck/orc';

const cardStyles = ({ fullWidth, theme }) => css`
  background: var(--white);
  box-shadow: ${theme.base.shadows.S};
  display: flex;
  flex-direction: column;
  width: calc(50% - 1.6rem);
  margin: 0.8rem;
  min-width: 71.5rem;
  ${fullWidth ? 'flex: 1' : ''}
  padding-bottom: 6px;
`;

const StyledCard = styled(Spacer)`
  ${cardStyles};
`;

export default StyledCard;
